import { type FSLocale, DEFAULT_LOCALE } from '../languages';
export default function localeLink(locale: FSLocale) {
	return (path = '') => {
		//already has the path
		if (path.startsWith(locale)) {
			//if it has the default, remove it
			return path.replace(`/${DEFAULT_LOCALE}`, '');
		}

		if (locale === DEFAULT_LOCALE) {
			//chop off the locale by default
			return path;
		}

		return `/${locale}${path}`;
	};
}
